// Module
var code = "<div class=\"row-item\" :class=\"sizeCssClass\">\n  <div class=\"row-item-label\" v-if=\"label\">{{ label }}</div>\n  <div class=\"row-item-value\" v-if=\"value\">{{ value }}</div>\n  <slot></slot>\n</div>\n";
// Exports
export default code;